import React from 'react'
import Navbar from '../components/global/Navbar'
import Bets from '../components/sports_bets/Bets'

const Sports = () => {
  return (
    <div>
        <Navbar/>
        <div>
            <Bets/>
        </div>
    </div>
  )
}

export default Sports